import { useGetBriefs } from "@entities/brief/lib/hooks/useGetBriefs";
import { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import {
  MY_PRICING_DEFAULT_PAGE_SIZE,
  MY_PRICING_SEGMENT,
  MyPricingSegment,
} from "../constants";

type UseMyPricingBriefsListParams = {
  userIdParam: string;
  selectedPocUserId?: string;
};

export function useMyPricingBriefsList({
  userIdParam,
  selectedPocUserId,
}: UseMyPricingBriefsListParams) {
  const [segment, setSegment] = useState<MyPricingSegment>(
    MY_PRICING_SEGMENT.Open
  );
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(MY_PRICING_DEFAULT_PAGE_SIZE);

  const [searchQuery, setSearchQuery] = useState<string>("");

  const activeUserId = (selectedPocUserId ?? userIdParam) || "";
  const isQueryEnabled = Boolean(activeUserId);

  const [debouncedSearchQuery] = useDebounce(searchQuery, 250);

  const { briefs, isFetching, totaldata } = useGetBriefs(
    {
      pageNo,
      limit: pageSize,
      searchQuery: debouncedSearchQuery,
      myPricingTracker: {
        userId: activeUserId,
        status: segment,
      },
    },
    isQueryEnabled
  );

  useEffect(() => {
    setPageNo(1);
  }, [segment, activeUserId, searchQuery]);

  const handlePaginationChange = (page: number, size: number) => {
    setPageNo(page);
    setPageSize(size);
  };

  return {
    segment,
    setSegment,
    searchQuery,
    setSearchQuery,
    pageNo,
    pageSize,
    briefs,
    isFetching,
    totaldata,
    activeUserId,
    handlePaginationChange,
  };
}
